// src/config.js
export const MUZAIC_ROOT = "https://app.muzaic.ai/";
export const MUZAIC_API_ROOT = "https://api.muzaic.ai/";
export const STRIPE_PUBLIC_KEY = "pk_live_51LnjLeIhLlnn3BvAThPRUBFVP3r9tzdWRAEwVngCMXRiUQatLW6TSNk7k5ZY1deErvat9qpdM2MvKGT6s3iLKplx001YFialAc";